export const allPossibleTopOpportunitiesOptions = {
  service: "Service",
  action_type: "Opportunity Type",
  "account.provider_account_id": "Account",
  "cluster.cluster_id": "Cluster",
  region: "Region",
  cloud_provider: "Cloud Provider",
};

export const topOpportunityMaxWidth = 110;
